import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_217e657c from 'nuxt_plugin_plugin_217e657c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_77e616c1 from 'nuxt_plugin_bootstrapvue_77e616c1' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_vlazyload_7f1b5c00 from 'nuxt_plugin_vlazyload_7f1b5c00' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_nuxtvuemultiselect_671be8bc from 'nuxt_plugin_nuxtvuemultiselect_671be8bc' // Source: ./nuxt-vue-multiselect.js (mode: 'all')
import nuxt_plugin_nuxtvueselect_fdd2638a from 'nuxt_plugin_nuxtvueselect_fdd2638a' // Source: ./nuxt-vue-select.js (mode: 'client')
import nuxt_plugin_vuesocialsharingplugin_830faeea from 'nuxt_plugin_vuesocialsharingplugin_830faeea' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_axios_72cfea92 from 'nuxt_plugin_axios_72cfea92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_ff5ff9a4 from 'nuxt_plugin_workbox_ff5ff9a4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_63423c41 from 'nuxt_plugin_metaplugin_63423c41' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_67e9e1b5 from 'nuxt_plugin_iconplugin_67e9e1b5' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_moment_144e0d74 from 'nuxt_plugin_moment_144e0d74' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_vueveevalidation_0373c73a from 'nuxt_plugin_vueveevalidation_0373c73a' // Source: ../plugins/vue-veevalidation.js (mode: 'all')
import nuxt_plugin_vuedynamicstarrating_5704d430 from 'nuxt_plugin_vuedynamicstarrating_5704d430' // Source: ../plugins/vue-dynamic-star-rating.js (mode: 'client')
import nuxt_plugin_mixinCommonMethods_41494e7d from 'nuxt_plugin_mixinCommonMethods_41494e7d' // Source: ../plugins/mixinCommonMethods.js (mode: 'client')
import nuxt_plugin_vuesocialsharing_1108e800 from 'nuxt_plugin_vuesocialsharing_1108e800' // Source: ../plugins/vue-social-sharing.js (mode: 'all')
import nuxt_plugin_googleanalyticsclient_3e5d1144 from 'nuxt_plugin_googleanalyticsclient_3e5d1144' // Source: ../plugins/google-analytics.client.js (mode: 'client')
import nuxt_plugin_ganalyticsclient_8c9aa3ec from 'nuxt_plugin_ganalyticsclient_8c9aa3ec' // Source: ../plugins/g-analytics.client.js (mode: 'client')
import nuxt_plugin_fbpixelcodeclient_46c3a9af from 'nuxt_plugin_fbpixelcodeclient_46c3a9af' // Source: ../plugins/fb-pixel-code.client.js (mode: 'client')
import nuxt_plugin_maps_e0cff0e8 from 'nuxt_plugin_maps_e0cff0e8' // Source: ../plugins/maps.js (mode: 'all')
import nuxt_plugin_jsonld_60b3ba23 from 'nuxt_plugin_jsonld_60b3ba23' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_vuepagination_ad5ea6bc from 'nuxt_plugin_vuepagination_ad5ea6bc' // Source: ../plugins/vue-pagination.js (mode: 'client')
import nuxt_plugin_slick_0bdbf753 from 'nuxt_plugin_slick_0bdbf753' // Source: ../plugins/slick.js (mode: 'client')
import nuxt_plugin_vuehorizontal_7ce293d8 from 'nuxt_plugin_vuehorizontal_7ce293d8' // Source: ../plugins/vue-horizontal.js (mode: 'client')
import nuxt_plugin_vueinfinitescroll_48ca0a2c from 'nuxt_plugin_vueinfinitescroll_48ca0a2c' // Source: ../plugins/vue-infinite-scroll.js (mode: 'client')
import nuxt_plugin_tabscrollclient_07990397 from 'nuxt_plugin_tabscrollclient_07990397' // Source: ../plugins/tab-scroll.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Goa App","htmlAttrs":{"lang":"en"},"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1 maximum-scale=1.0, user-scalable=no"},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#ff9012"},{"name":"theme-color","content":"#ff9012"},{"name":"copyright","content":"Goa App"},{"hid":"t-url","name":"twitter:app:url:googleplay","content":"https:\u002F\u002Fplay.google.com\u002Fstore\u002Fapps\u002Fdetails?id=goa.tourism"},{"hid":"t-id","name":"twitter:app:id:googleplay","content":"goa.tourism"},{"hid":"robots","name":"robots","content":"max-image-preview:large"},{"hid":"og:site_name","property":"og:site_name","content":"Goa App"},{"hid":"og:locale","property":"og:locale","content":"en_US"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fgoa.app"},{"hid":"al:ios:app_store_id","property":"al:ios:app_store_id","content":"6463205036"},{"hid":"al:ios:app_name","property":"al:ios:app_name","content":"Goa Tourism Travel Guide"},{"hid":"al:ios:url","property":"al:ios:url","content":"https:\u002F\u002Fapps.apple.com\u002Fin\u002Fapp\u002Fgoa-tourism-travel-guide\u002Fid6463205036"},{"hid":"al:android:url","property":"al:android:url","content":"https:\u002F\u002Fplay.google.com\u002Fstore\u002Fapps\u002Fdetails?id=goa.tourism"},{"hid":"al:android:app_name","property":"al:android:app_name","content":"Goa Tourism Travel Guide"},{"hid":"al:android:package","property":"al:android:package","content":"goa.tourism"},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","property":"twitter:site","content":"@goaapp"},{"hid":"twitter:app:country","property":"twitter:app:country","content":"IN"},{"hid":"twitter:app:name:iphone","property":"twitter:app:name:iphone","content":"Goa Tourism Travel Guide"},{"hid":"twitter:app:id:iphone","property":"twitter:app:id:iphone","content":"6463205036"},{"hid":"twitter:app:url:iphone","property":"twitter:app:url:iphone","content":"https:\u002F\u002Fapps.apple.com\u002Fin\u002Fapp\u002Fgoa-tourism-travel-guide\u002Fid6463205036"}],"link":[{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","color":"#ffb663","href":"\u002Fsafari-pinned-tab.svg"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Nunito:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fslick-carousel@1.8.1\u002Fslick\u002Fslick.css"}],"script":[{"src":"\u002Fbootstrap\u002Fbootstrap.min.js","defer":true},{"src":"https:\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js?client=ca-pub-9801716291994645","body":false,"async":true,"crossorigin":"anonymous"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_217e657c === 'function') {
    await nuxt_plugin_plugin_217e657c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_77e616c1 === 'function') {
    await nuxt_plugin_bootstrapvue_77e616c1(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_7f1b5c00 === 'function') {
    await nuxt_plugin_vlazyload_7f1b5c00(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuemultiselect_671be8bc === 'function') {
    await nuxt_plugin_nuxtvuemultiselect_671be8bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvueselect_fdd2638a === 'function') {
    await nuxt_plugin_nuxtvueselect_fdd2638a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_830faeea === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_830faeea(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_72cfea92 === 'function') {
    await nuxt_plugin_axios_72cfea92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_ff5ff9a4 === 'function') {
    await nuxt_plugin_workbox_ff5ff9a4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_63423c41 === 'function') {
    await nuxt_plugin_metaplugin_63423c41(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_67e9e1b5 === 'function') {
    await nuxt_plugin_iconplugin_67e9e1b5(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_144e0d74 === 'function') {
    await nuxt_plugin_moment_144e0d74(app.context, inject)
  }

  if (typeof nuxt_plugin_vueveevalidation_0373c73a === 'function') {
    await nuxt_plugin_vueveevalidation_0373c73a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedynamicstarrating_5704d430 === 'function') {
    await nuxt_plugin_vuedynamicstarrating_5704d430(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mixinCommonMethods_41494e7d === 'function') {
    await nuxt_plugin_mixinCommonMethods_41494e7d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharing_1108e800 === 'function') {
    await nuxt_plugin_vuesocialsharing_1108e800(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalyticsclient_3e5d1144 === 'function') {
    await nuxt_plugin_googleanalyticsclient_3e5d1144(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ganalyticsclient_8c9aa3ec === 'function') {
    await nuxt_plugin_ganalyticsclient_8c9aa3ec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fbpixelcodeclient_46c3a9af === 'function') {
    await nuxt_plugin_fbpixelcodeclient_46c3a9af(app.context, inject)
  }

  if (typeof nuxt_plugin_maps_e0cff0e8 === 'function') {
    await nuxt_plugin_maps_e0cff0e8(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_60b3ba23 === 'function') {
    await nuxt_plugin_jsonld_60b3ba23(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepagination_ad5ea6bc === 'function') {
    await nuxt_plugin_vuepagination_ad5ea6bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_slick_0bdbf753 === 'function') {
    await nuxt_plugin_slick_0bdbf753(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehorizontal_7ce293d8 === 'function') {
    await nuxt_plugin_vuehorizontal_7ce293d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfinitescroll_48ca0a2c === 'function') {
    await nuxt_plugin_vueinfinitescroll_48ca0a2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tabscrollclient_07990397 === 'function') {
    await nuxt_plugin_tabscrollclient_07990397(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
